<template>
  <div
    class="date-picker month-picker d-flex align-center"
    v-shortkey="shortkeys"
    @shortkey="handleShortkeys"
  >
    <v-btn
      text
      class="ml-2"
      x-small
      depressed
      max-width="32px"
      height="32px"
      color="primary"
      @click="changeYear()"
    >
      <v-icon>
        mdi-chevron-double-left
      </v-icon>
    </v-btn>
    <v-btn
      text
      x-small
      depressed
      max-width="32px"
      height="32px"
      color="primary"
      class="mr-1"
      @click="changeMonth()"
    >
      <v-icon>
        mdi-chevron-left
      </v-icon>
    </v-btn>
    <v-menu
      v-model="showDatePicker"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="350px"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          class="date-picker__input month-picker__input"
          :value="formattedDate"
          readonly
          single-line
          outlined
          hide-details
          v-bind="attrs"
          v-on="on"
          @click.native="showDatePicker = !showDatePicker"
        >
          <template #prepend-inner>
            <Icon
              name="date"
              size="small"
              class="mr-2"
            />
          </template>
        </v-text-field>
      </template>
      <div class="date-picker__content">
        <v-date-picker
          v-model="localMonth"
          type="month"
          v-bind="attributes.datePicker"
        />
        <div class="date-picker__presets d-flex justify-end pa-2">
          <v-btn
            outlined
            color="primary"
            @click="closePicker"
          >
            Anuluj
          </v-btn>
          <v-btn
            class="base-hover ml-2"
            :disabled="localMonth === value"
            color="primary"
            @click="confirmMonth"
          >
            Zatwierdź
          </v-btn>
        </div>
      </div>
    </v-menu>
    <v-btn
      text
      class="ml-1"
      x-small
      depressed
      max-width="32px"
      height="32px"
      color="primary"
      @click="changeMonth(true)"
    >
      <v-icon>
        mdi-chevron-right
      </v-icon>
    </v-btn>
    <v-btn
      text
      class="mr-2"
      x-small
      depressed
      max-width="32px"
      height="32px"
      color="primary"
      @click="changeYear(true)"
    >
      <v-icon>
        mdi-chevron-double-right
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import DateTime from 'luxon/src/datetime'
import attributes from '../../const/datePickerAttrributes'
import { toggleButtonsShortkeys } from '../../const/shortKeys'
import { dateStringFormat } from '../../utils'

const shortkeys = {
  ...toggleButtonsShortkeys
}

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    showDatePicker: false,
    localMonth: '',
    attributes,
    shortkeys
  }),
  computed: {
    monthDate () {
      return DateTime.fromISO(`${this.value}-01`)
    },
    formattedDate () {
      const start = this.monthDate.startOf('month')
      const end = this.monthDate.endOf('month')
      return `${dateStringFormat(start.toISODate())}, ${dateStringFormat(end.toISODate())}`
    }
  },
  watch: {
    showDatePicker (showPicker) {
      if (showPicker) this.localMonth = this.value
    },
    value (month) {
      this.localMonth = month
    }
  },
  mounted () {
    this.localMonth = this.value
  },
  methods: {
    handleShortkeys (event) {
      switch (event.srcKey) {
        case 'ctrll':
        case 'cmdl':
          this.changeMonth()
          break
        case 'ctrlr':
        case 'cmdr':
          this.changeMonth(true)
          break
      }
    },
    emitMonth (date) {
      this.$emit('input', date.toFormat('yyyy-MM'))
    },
    changeMonth (inc) {
      this.emitMonth(this.monthDate.plus({ months: inc ? 1 : -1 }))
    },
    changeYear (inc) {
      this.emitMonth(this.monthDate.plus({ years: inc ? 1 : -1 }))
    },
    confirmMonth () {
      this.$emit('input', this.localMonth)
      this.closePicker()
    },
    closePicker () {
      this.localMonth = this.value
      this.showDatePicker = false
    }
  }
}
</script>

<style lang="scss" scoped>
.month-picker__input {
  width: 270px;
}

.month-picker__input::v-deep .v-input__append-inner {
  margin-top: 9px !important;
}

.month-picker__input ::v-deep .v-input__control > .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
